import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import useAppConfig from "../../hooks/useAppConfig";
import { getTicketDeskToken } from "../../service/ticket-desk";
import config from "../../config";
import Loader from "../../shared/components/UI/Loader";

// pwa theme need to be implemented
const theme = {
  font: {
    meta: {
      type: "typography",
    },
    name: "font",
    type: "font",
    label: "",
    value: "Roboto",
    options: ["Roboto", "Montserrat", "Nunito"],
  },
  primary: {
    meta: {
      type: "palette",
    },
    name: "primary",
    type: "color",
    label: "Set Primary Color theme",
    value: "#F2755F",
    options: [],
  },
  textColor: {
    meta: {
      type: "palette",
    },
    name: "textColor",
    type: "color",
    label: "Set Side Nav text theme",
    value: "#232d48",
    options: [],
  },
  background: {
    meta: {
      type: "palette",
    },
    name: "background",
    type: "color",
    label: "Set Side Nav theme",
    value: "#fff",
    options: [],
  },
  dashboardTheme: {
    primary: {
      dark: "#B43721",
      main: "#F2755F",
      light: "#FEF4F2",
      contrastText: "#FFFFFF",
    },
  },
};

const TicketDesk = () => {
  const { ticketDeskUrl } = config;
  const appConfig = useAppConfig();
  const selectedBusinessId = appConfig?.appConfig?.selecteBussines?.id;
  const [token, setToken] = useState(null);
  const { breakpoints } = useTheme();
  const isMobileView = useMediaQuery(breakpoints.down("md"));

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "zammad-route") {
        const path = event.data.path;
        const url = new URL(window.location.href);
        !isMobileView
          ? url.searchParams.set("tdr", path)
          : url.searchParams.delete("tdr");
        window.history.replaceState({}, "", url);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const payload =
    token && theme
      ? encodeURIComponent(JSON.stringify({ token, theme }))
      : null;
  const url = new URL(window.location.href);
  const encodedTdr = url.searchParams.get("tdr");
  const tdr = encodedTdr ? decodeURIComponent(encodedTdr) : null;

  const ticketDeskSrc =
    tdr && !isMobileView
      ? `${ticketDeskUrl}?payload=${payload}${tdr}`
      : `${ticketDeskUrl}?payload=${payload}`;

  useEffect(() => {
    getTicketDeskToken(selectedBusinessId)
      .then((data) => {
        setToken(data.token);
      })
      .catch((err) => console.log(err));
  }, [selectedBusinessId]);
  if (!token) return <Loader />;
  return (
    <Box>
      <iframe
        style={{
          border: "none",
          width: "100%",
          minHeight: isMobileView
            ? "calc(100vh - 4.75rem)"
            : "calc(100vh - 10.75rem)",
        }}
        allow="clipboard-write; notifications; microphone; camera; display-capture; autoplay"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
        src={ticketDeskSrc}
        title={"Ticket Desk"}
        id={"ticket-desk"}
      />
    </Box>
  );
};

export default TicketDesk;
